import React from 'react';
import PropTypes from 'prop-types';

import getApi from '../helpers/GetApi';
import config from '../config/config.json';

import Form from './Form';

const propTypes = {
  isSending: PropTypes.bool.isRequired,
  onSubmitForm: PropTypes.func.isRequired,
  selectedItems: PropTypes.arrayOf(PropTypes.string).isRequired,
  toggleTerms: PropTypes.func.isRequired,
};

class Questionnaire extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      name: '',
      terms: false,
    };
  }

  handleSubmitForm(event) {
    event.preventDefault();

    const { email, name, terms } = this.state;
    const { onSubmitForm, selectedItems } = this.props;

    // Generate data for competition API
    const formData = {
      allowads1: terms ? 1 : 0,
      emailfield: email,
      game: `islist${config.CUSTOMER_ID}`,
      namefield: name,
      extra1: selectedItems,
    };

    const api = getApi(process.env.NODE_ENV);
    const url = `${api}competition/islist/${config.CUSTOMER_ID}`;

    onSubmitForm(url, formData);
  }

  handleInputChange(event) {
    const { state } = this;
    const { type } = event.target;
    let { value } = event.target;

    if (type === 'checkbox') {
      value = event.target.checked;
    }

    this.setState({
      ...state,
      [event.target.name]: value,
    });
  }

  render() {
    const { email, name, terms } = this.state;
    const { isSending, selectedItems, toggleTerms } = this.props;

    return (
      <>
        <h2 className="h2 form-title">
          Lisää alle vielä tietosi ja osallistu arvontaan!
        </h2>
        <Form
          email={email}
          handleInputChange={(event) => this.handleInputChange(event)}
          handleSubmit={(event) => this.handleSubmitForm(event)}
          isSending={isSending}
          name={name}
          selectedItems={selectedItems}
          terms={terms}
          toggleTerms={toggleTerms}
        />
      </>
    );
  }
}

Questionnaire.propTypes = propTypes;

export default Questionnaire;
